import { render, staticRenderFns } from "./menulist.vue?vue&type=template&id=470c6a1a&"
import script from "./menulist.vue?vue&type=script&lang=js&"
export * from "./menulist.vue?vue&type=script&lang=js&"
import style0 from "./menulist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports